import { AnimatePresence } from 'framer-motion';
import { Modal } from '@snapi/layout';
import {
  ForwardedRef,
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';
import { useToggle } from 'react-use';
import { BabyEditForm } from './baby-edit-form';
import { Baby } from '@snapi/types';

export interface BabyEditModalRef {
  edit: (baby: Baby) => void;
  add: () => void;
}

export interface BabyEditModalProps {
  onSave(baby: Baby): Promise<void>;
}

export const BabyEditModal = forwardRef<BabyEditModalRef, BabyEditModalProps>(
  ({ onSave }: BabyEditModalProps, ref: ForwardedRef<BabyEditModalRef>) => {
    const [baby, setBaby] = useState<Partial<Baby> | null>(null);
    const [on, toggle] = useToggle(false);
    const closeModal = () => toggle(false);

    useEffect(() => {
      if (baby) {
        toggle(true);
      }
    }, [baby]);

    useImperativeHandle(ref, () => ({
      edit: (baby: Baby) => {
        setBaby(baby);
        toggle(true);
      },
      add: () => {
        setBaby({});
      },
    }));

    return (
      <AnimatePresence initial={false} exitBeforeEnter>
        {on && (
          <Modal onClose={closeModal}>
            <BabyEditForm baby={baby} onSave={onSave} onCancel={closeModal} />
          </Modal>
        )}
      </AnimatePresence>
    );
  }
);
